// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1165 ? "dd3ef7d3" : chunkId) + "." + {"889":"9bf6dc4cc3c2ff58","1165":"5c2bafa70e518e72","8023":"242a02c8f4530ef6","8682":"22c9d3bab710d6b8"}[chunkId] + ".js";
};